import { Component } from '@angular/core';
import { LoadingSpinnerComponent } from '@zeiss/beyond-online-angular';
@Component({
	selector: 'app-loading-animation-container',
	templateUrl: './loading-animation-container.component.html',
	imports: [LoadingSpinnerComponent],
})
export class LoadingAnimationContainerComponent {}
